











































import Vue from 'vue'
import moment from 'moment'
import { Contest as ContestInterface } from '@/model/Contest';

export default Vue.extend({
  name: 'TemporaryContestBanner',

  computed: {
    isSignedIn(): boolean {
      return (this as any).$store.state.authentication.signedIn
    },
  },

  mounted() {
    (this as any).animateBackground({clientX: 0, clientY: 0} as MouseEvent)
    this.fetchMeters();
  },

  methods: {
    updateCursorPosition(point: { x: number; y: number }): void {
      (this as any).cursorX = point.x;
      (this as any).cursorY = point.y;
    },

    moveImages(): void {
      const cursorXPercent = (this as any).cursorX / window.innerWidth;

      (this as any).scatteredImages.forEach((image: {src: string; style: object; threshold: number}, index: number) => {
        const newTranslate = cursorXPercent * this.scatteredImages[index].threshold;
        (this as any).scatteredImages[index].style.transform = `translate(${newTranslate}px, 0)`;
      });
    },

    animateBackground(event: MouseEvent): void {
      (this as any).updateCursorPosition({x: event.clientX, y: event.clientY});
      (this as any).moveImages();
    },

    fetchMeters() {
      this.$api.get('/contests')
        .then((res: any) => {
          this.meters.totalContests.value = res.data['hydra:member'].filter((contest: ContestInterface) => {
            if (moment(contest.endAt).isBefore(moment())) return false;

            return true;
          }).length;
          const totalToWin = res.data['hydra:member'].reduce((acc: number, contest: ContestInterface) => {
            if (moment(contest.endAt).isBefore(moment())) return acc;

            return acc + contest.rewardsValue;
          }, 0);
          this.meters.totalToWin.value = '$' + totalToWin;
        });
      this.$api.get('/projects')
        .then((res: any) => this.meters.totalProjects.value = res.data['hydra:totalItems']);
    }
  },

  data: () => ({
    cursorX: 0,
    cursorY: 0,
    scatteredImages: [
      {
        src: require('@/assets/shapes/line-slim.svg'),
        style: {bottom: '100px', left: '100px', transform: 'translate(0, 0)', opacity: 0.7, height: '130px'},
        threshold: 30
      },
      {
        src: require('@/assets/shapes/circle.svg'),
        style: {bottom: '208px', left: '160px', transform: 'translate(0, 0)'},
        threshold: -47
      },
      {
        src: require('@/assets/shapes/double-line.svg'),
        style: {bottom: '-70px', left: '30%', transform: 'translate(0, 0)'},
        threshold: 60
      },
      {
        src: require('@/assets/shapes/circle.svg'),
        style: {top: '30px', right: '54%', transform: 'translate(0, 0)'},
        threshold: -50
      },
      {
        src: require('@/assets/shapes/line-slim.svg'),
        style: {top: '300px', right: 0, transform: 'translate(0, 0)'},
        threshold: -50
      },
      {
        src: require('@/assets/shapes/line-thick.svg'),
        style: {top: 0, right: '55%', transform: 'translate(0, 0)'},
        threshold: -30
      },
      {
        src: require('@/assets/shapes/plus.svg'),
        style: {top: '250px', right: '9%', transform: 'translate(0, 0)'},
        threshold: 53
      }
    ],
    meters: {
      totalContests: {
        label: "Ongoing contests",
        value: 0,
      },
      totalProjects: {
        label: "Total projects",
        value: 0,
      },
      totalToWin: {
        label: "Sum of prizes",
        value: '$0',
      },
    }
  }),
})
